import React from 'react'
import { Gallery } from './MainInfo/Gallery'
import { ProductInfo } from './MainInfo/ProductInfo'
import { Col, Container, Row } from 'react-bootstrap'

export const MainInfoContainer = () => {
  return (
    <section className="  py-5">
      <Container>
        <Row>
          <Col md={6}>
            <Gallery />
          </Col>
          <Col md={6}>
            <ProductInfo />
          </Col>
        </Row>
      </Container>
    </section>
  )
}
